import * as React from 'react';

import { Icon } from '@base/components/Icon';

import { IconAppClose } from '@icons';

import { IAppDialogProps } from './types';

import * as s from './AppDialog.scss';

export const AppDialog = ({
	visible,
	title,
	onClose,
	children,
	onScroll,
}: IAppDialogProps) =>
	visible
		? <div className={s.dialog}>
			<header className={s.header}>
				<Icon glyph={IconAppClose} className={s.close} onClick={onClose} />
				<h1 className={s.title}>{title}</h1>
			</header>
			<main className={s.body} onScroll={onScroll || null}>{children}</main>
		</div>
		: null;
